import React, { useState, useEffect } from "react";
import UISectionHeading from "../Common/UISectionHeading/UISectionHeading";
import UiButton from "../Common/UiButton/UiButton";
import { Col, Row } from "react-bootstrap";
import { Form, message, Checkbox } from "antd";
import TextInput from "../Common/UITextInput/TextInput";
import "../EngagementDetails/EngagementDetails.css";
import VerificationIc from "../../images/Verified-Partner.png";
import { getTeamsPanDetailAll } from "../../redux/TeamDetailsMaster/action";
import { saveTeamsPanDetails } from "../../redux/TeamPanVerification/action";
import { connect } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, notification } from "antd";
import useSession from "../CustomLogout/useSession";

const TeamsPanVerification = (props) => {
  const handleSessionExpired = useSession();

  const [form] = Form.useForm();
  const FormItem = Form.Item;

  const { saveAllIndication, setHandleGetTeamPan } = props;
  const [partnerFirmMSMEFlagCheck, setPartnerFirmMSMEFlagCheck] =
    useState(false);

  const [disabled, setDisabled] = useState(true);
  const [panNotext, setpanNotext] = useState("");
  const [showText, setShowText] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const Id = sessionStorage.getItem("cetFirmId");
  const [btnDisable, setBtnDisable] = useState(false);
  const [showEditBtn, setShowEditBtn] = useState(false);
  const onChangeTextHandler = (event) => {
    const result = event.target.value.toUpperCase();
    setpanNotext(result);
  };

  const toggle = () => {
    setDisabled(!disabled);
    // setBtnDisable(false);
  };

  useEffect(() => {
    if (saveAllIndication) {
      form.submit();
    }
  }, [saveAllIndication]);

  useEffect(() => {
    if (props.personId == undefined) {
      setPartnerFirmMSMEFlagCheck(false);
      setpanNotext("");
      setBtnDisable(false);
      setShowText(false);
      setShowEditBtn(false);

      setDisabled(true);
    }
    form.setFieldsValue({
      partnerTeamPanNumber: panNotext,
    });

    if (props.data && props.personId !== undefined) {
      const getAllPanTeamsDetails = props.data?.teamsPanDataList?.dto ?? "";

      setpanNotext(getAllPanTeamsDetails?.partnerTeamPanNumber);
      setPartnerFirmMSMEFlagCheck(getAllPanTeamsDetails?.partnerTeamPanConsent);

      form.setFieldsValue({
        partnerTeamPanNumber:
          props.data?.teamsPanDataList?.dto?.partnerTeamPanNumber,
      });
    }

    if (
      props.data?.teamsPanDataList?.dto?.isVerified === true &&
      props?.personId !== undefined
    ) {
      setShowText(true);
      setDisabled(true);
      setShowEditBtn(true);
      setBtnDisable(true);
    }
    if (props.data?.teamsPanDataList?.dto?.isVerified == false) {
      setShowText(false);
      setDisabled(false);
      setShowEditBtn(false);
    }
  }, [props.data, props?.personId]);

  const onClickChange = (user) => {
    setDisabled(true);
    const panTeamsVerificationData = {
      partnerPersonId: props.personId,
      partnerFirmId: props?.state?.checkLogin?.partnerFirmId || Id,
      partnerTeamPanNumber: panNotext,
      partnerTeamPanConsent: partnerFirmMSMEFlagCheck,
    };

    if (saveAllIndication) {
      setHandleGetTeamPan(panTeamsVerificationData);
      setDisabled(false);
    } else {
      setSaveLoading(true);
      props
        .saveTeamsPanDetails({
          values: panTeamsVerificationData,
          access_token: props.access_token,
          // partnerFirmId: props.firmId,
        })
        .then((res) => {
          setSaveLoading(false);
          if (res && res.status === 200) {
            message.success("Saved");
            setShowText(true);
            setDisabled(false);
            setTimeout(() => {
              setShowEditBtn(true);
            }, 3000);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;
            setDisabled(false);
            setSaveLoading(false);
            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((e) => {
          setDisabled(false);
          setSaveLoading(false);
          setSaveLoading(false);
        });
    }
  };

  const handlEditChanges = () => {
    setPartnerFirmMSMEFlagCheck(false);
    setBtnDisable(false);
    setShowText(false);
    setDisabled(true);
    setShowEditBtn(false);
    setpanNotext("");
  };

  console.log("line 154", props.data?.teamsPanDataList?.dto);
  return (
    <div>
      <Form
        autoComplete="off"
        name="teamsPanVerification"
        form={form}
        onFinish={onClickChange}
      >
        <div className="inner-content">
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="content-Section">
              <Col md={6} className="leftsidecontent">
                <div className="subheading">
                  <UISectionHeading secHeading="PAN Verification" />
                </div>
              </Col>
              <Col md={6} className="right-field-section">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col
                      md={6}
                      className="Mobile-sec pan-mob"
                      style={{ width: "40%" }}
                    >
                      {/* <FormItem name="partnerTeamPanNumber" colon={false}> */}
                      <TextInput
                        maxLength={10}
                        title="Pan Number"
                        defaultValue={panNotext}
                        disabled={showEditBtn}
                        name="partnerTeamPanNumber"
                        onChange={onChangeTextHandler}
                        value={panNotext}
                        type="text"
                        validation={[
                          {
                            required: true,
                            message: "PAN number Required",
                          },

                          // {
                          //   pattern: new RegExp(
                          //     "([A-Z]){5}([0-9]){4}([A-Z]){1}$"
                          //   ),
                          //   message: "Invalid PAN format",
                          // },
                        ]}
                      />
                      {/* </FormItem> */}
                    </Col>
                    <Col md={6} className="btn-verify">
                      <div className="verfication-opt-btn">
                        {showText ? (
                          <img
                            className="verifi-ic-btn"
                            src={VerificationIc}
                            alt=""
                          />
                        ) : (
                          <UiButton
                            disabled={disabled}
                            type="submit"
                            title="Verify"
                          // onClick={onClickChange}
                          />
                        )}
                        {showEditBtn ? (
                          <div className="btn-edit-sec">
                            <UiButton
                              type="save"
                              title="Change/Edit"
                              onClick={handlEditChanges}
                            />
                          </div>
                        ) : null}

                        {saveLoading && (
                          <div className="pr-4 spanner">
                            <Spin
                              size="large"
                              className="pr-4"
                              indicator={
                                <LoadingOutlined style={{ color: "#00d8db" }} />
                              }
                            ></Spin>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={6} className="check-sec-1 pan-ver">
                      <FormItem
                        colon={false}
                        rules={[
                          {
                            required: true,
                            message: "PAN number is incorrect",
                          },
                        ]}
                      >
                        <Checkbox
                          value={partnerFirmMSMEFlagCheck}
                          checked={partnerFirmMSMEFlagCheck}
                          disabled={btnDisable}
                          // disabled={
                          //   props.data?.teamsPanDataList?.dto
                          //     ?.partnerTeamPanConsent === false
                          //     ? true
                          //     : false
                          // }
                          name="partnerTeamPanConsent"
                          onClick={toggle}
                          onChange={() =>
                            setPartnerFirmMSMEFlagCheck(
                              !partnerFirmMSMEFlagCheck
                            )
                          }
                        >
                          <p className="text-left">
                            By clicking on the checkbox, you provide express
                            consent and authorization, voluntarily,to Avanse
                            Financial Services Limited to
                            <br />
                            (i) retrieve your PAN information through a third
                            party services provider Karza.
                            <br />
                            (ii) Use this information for identification,
                            verification and due-diligence purposes.
                          </p>
                        </Checkbox>
                      </FormItem>
                    </Col>
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>
          <div className="pan-last-sec"></div>
          <hr></hr>
        </div>
      </Form>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveTeamsPanDetails: (data) => dispatch(saveTeamsPanDetails(data)),
    getData: (accessToken) => dispatch(getTeamsPanDetailAll(accessToken)),
  };
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    data: state.teamsMasterData,
    partnerPersonId: state.saveDirectorDetails.partnerPersonID,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamsPanVerification);
